import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux'
import moment from 'moment';
import { SvgCheck } from '../svg';

const translations = [
  gettext('Existing payment method'),
  gettext('Send Payment Form'),
  gettext('Payment processor'),
  gettext('Last four'),
  gettext('Valid until'),
  gettext('Added at'),
  gettext('Verified'),
  gettext('No card found for this user'),
  gettext('Send paymentform to email address'),
  gettext('Send paymentform to phone no'),
  gettext('Valid email or phone is needed for this payment option'),
]

const PaymentForm = ({ callback }) => {
  const [selectedMethod, setSelectedMethod] = useState('Card');
  const [paymentFormSelection, setPaymentFormSelection] = useState('Email');
  const [selectedCard, setSelectedCard] = useState();
  const selectedCustomer = useSelector((state) => state.customers.selectedCustomer);
  const cardArray = useSelector((state) => state.customers.selectedCustomer?.payment_method);

  const paymentOptions = [
    { value: 'Card', text: gettext('Existing payment method') },
    { value: 'Form', text: gettext('Send Payment Form') },
    // { value: 'Slip', text: gettext('Payment Slip') }
  ].filter(option => {
    if (option.value === 'Card') {
      if (cardArray && cardArray.length > 0 ) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  })

  const cardInfo = [
    { value: 'payment_processor', text: gettext('Payment processor'), class: 'col-2 mb-4', type: 'string' },
    { value: 'display_info', text: gettext('Last four'), class: 'col-4 mb-4', type: 'string' },
    { value: 'valid_until', text: gettext('Valid until'), class: 'col-2 mb-4', type: 'date' },
    { value: 'added_at', text: gettext('Added at'), class: 'col-3 mb-4', type: 'date' },
    { value: 'verified', text: gettext('Verified'), class: 'col-1 mb-4', type: 'icon' }
  ];

  
  useEffect(() => {
    if(selectedMethod == 'Card' && selectedCard){
      callback(selectedMethod, selectedCard)
    } else if(selectedMethod == 'Form'){
      if (selectedCustomer.email || selectedCustomer.phone) {
        callback(selectedMethod, paymentFormSelection)
      }
    }
  }, [selectedCard, selectedMethod, paymentFormSelection])


  const CardComponent = ({ item }) => {
    return (
      <div className={`row align-items-end ${selectedCard === item ? 'selected' : 'not-selected'}`} onClick={() => setSelectedCard(item)}>
        {cardInfo.map(option =>
          <div className={option.class} key={option.value} >
            <label>{gettext(option.text)}</label>
            {option.type === 'date' && <p>{moment(item[option.value]).format('DD.MM.YYYY')}</p>}
            {option.type === 'string' && <p>{item[option.value]}</p>}
            {option.type === 'icon' && <p><SvgCheck></SvgCheck></p>}
          </div>
        )}
      </div>
    )
  }

  return (
    <>
      <div className="row align-items-end">
        {paymentOptions.map(option => (
          <div className="col-4 mb-4 mb-5 d-flex align-items-center" key={option.value}>
            <input
              type="radio"
              value={option.value}
              name="payment"
              checked={selectedMethod === option.value}
              onChange={() => setSelectedMethod(option.value)}
              id={option.value}
              className="mb-2"
            />
            <label className="mb-2" htmlFor={option.value}>{gettext(option.text)}</label>
          </div>
        ))}
      </div>
      {selectedMethod === 'Card' &&
        <>
          { cardArray && cardArray.length > 0 ? (
            <>
              <div>
                {cardArray.map((item, index) => {
                  if (item.verified && !item.cancelled) {
                    return <CardComponent item={item} key={item.id}></CardComponent>
                  } else {
                    return null;
                  }
                })}
              </div>
            </>
          )
            :
            <div>{gettext('No card found for this user')}</div>
          }
        </>
      }
      {selectedMethod === 'Form' &&
        <>
          {selectedCustomer.email || selectedCustomer.phone ?
            <>
            { selectedCustomer.email &&
              <div>
                <input type="radio" value="Email" name="send_type" onChange={() => setPaymentFormSelection('Email')} checked={paymentFormSelection === 'Email'} />
                {gettext('Send paymentform to email address') + ' ' + selectedCustomer.email}
              </div>
            }
            { selectedCustomer.phone && 
              <div>
                <input type="radio" value="SMS" name="send_type" onChange={() => setPaymentFormSelection('SMS')} checked={paymentFormSelection === 'SMS'} />
                {gettext('Send paymentform to phone no') + ' ' + selectedCustomer.phone}
              </div>
            }
            </>
            :
            <div>{gettext('Valid email or phone is needed for this payment option')}</div>
          }
        </>
      }
      {/* {selectedMethod === 'Slip' && (
        <div>
          
        </div>
      )} */}
    </>
  );
};

export default PaymentForm;
